module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rp-layer",
    class: {
      '-selected': _vm.selected, '-invisible': !_vm.layer.visible, '-highlighted': _vm.highlighted
    },
    on: {
      "click": function($event) {
        _vm.selectLayer()
      }
    }
  }, [_c('a', {
    staticClass: "rp-layer-header",
    class: {
      '-inactive': !_vm.layer.visible, '-active': _vm.selected
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.switchLayerExpanded
    }
  }, [_c('div', {
    staticClass: "rp-layer-header-expand-icon"
  }, [_c('span', {
    staticClass: "icon",
    class: {
      'icon-calcplus': !_vm.layer.expanded, 'icon-calcminus': _vm.layer.expanded
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "rp-layer-header-title"
  }, [_vm._v(_vm._s(_vm.layer.name))]), _vm._v(" "), _c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "before-enter": _vm.iconAnimBeforeEnter,
      "enter": _vm.iconAnimEnter,
      "leave": _vm.iconAnimLeave
    }
  }, [(_vm.selected) ? _c('div', {
    staticClass: "rp-layer-header-expand-icon",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.editLayer($event)
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-cog"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "rp-layer-header-visible-icon",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.switchLayerVisible($event)
      }
    }
  }, [_c('span', {
    staticClass: "icon",
    class: {
      'icon-check': _vm.layer.visible, 'icon-uncheck': !_vm.layer.visible
    }
  })])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "before-enter": _vm.bodyAnimBeforeEnter,
      "enter": _vm.bodyAnimEnter,
      "leave": _vm.bodyAnimLeave
    }
  }, [(_vm.layer.expanded) ? _c('div', {
    staticClass: "rp-layer-body-container"
  }, [_c('div', {
    staticClass: "rp-layer-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEmpty),
      expression: "showEmpty"
    }],
    ref: "empty",
    staticClass: "rp-layer-body-empty"
  }, [_vm._v("-- Empty --")]), _vm._v(" "), _c('Draggable', {
    staticClass: "rp-layer-body-list",
    attrs: {
      "options": {
        group: 'shapes',
        handle: '.rp-layer-draggable'
      },
      "value": _vm.shapes,
      "move": _vm.checkMove,
      "data-layer-id": _vm.layer.id
    },
    on: {
      "start": function($event) {
        _vm.startMove($event)
      },
      "end": function($event) {
        _vm.moveShape($event)
      }
    }
  }, [_vm._l((_vm.shapes), function(s) {
    return [(s.type == 'marker') ? [_c('a', {
      key: s.id,
      staticClass: "rp-layer-marker rp-layer-draggable",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.flyToAndShowMarkerInfo(s)
        }
      }
    }, [_c('i', {
      staticClass: "rp-layer-marker-icon",
      style: ({
        backgroundImage: 'url(' + s.icon + ')'
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "rp-layer-marker-text"
    }, [_vm._v(_vm._s(s.name))])])] : _vm._e(), _vm._v(" "), (s.type == 'dot') ? [_c('a', {
      key: s.id,
      staticClass: "rp-layer-marker rp-layer-draggable",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.flyToAndShowDotInfo(s)
        }
      }
    }, [_c('i', {
      staticClass: "rp-layer-marker-icon",
      style: ({
        backgroundImage: 'url(' + s.icon + ')'
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "rp-layer-marker-text"
    }, [_vm._v(_vm._s(s.name))])])] : _vm._e(), _vm._v(" "), (s.type == 'polygon') ? [_c('a', {
      key: s.id,
      staticClass: "rp-layer-polygon rp-layer-draggable",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.flyToAndShowPolygonInfo(s)
        }
      }
    }, [_c('span', {
      staticClass: "icon icon-transform"
    }), _vm._v(" "), _c('span', {
      staticClass: "rp-layer-polygon-text"
    }, [_vm._v(_vm._s(s.name))])])] : _vm._e(), _vm._v(" "), (s.type == 'route') ? [_c('div', {
      key: s.id,
      ref: 'shape' + s.id,
      refInFor: true,
      staticClass: "rp-layer-route rp-layer-draggable"
    }, [_c('div', {
      staticClass: "clearfix"
    }, [_c('div', {
      staticClass: "rp-layer-route-header pull-left"
    }, [(s.editing) ? _c('span', {
      staticClass: "icon icon-directions"
    }) : _vm._e(), _vm._v(" "), (!s.editing) ? _c('span', {
      staticClass: "icon fa-icon",
      class: 'icon-' + s.mode
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "rp-layer-route-header-text",
      domProps: {
        "textContent": _vm._s(_vm.routeName(s))
      }
    })]), _vm._v(" "), (s.editing) ? _c('a', {
      staticClass: "rp-layer-route-header-control",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.remove(s)
        }
      }
    }, [_c('span', {
      staticClass: "icon-times"
    })]) : _c('a', {
      staticClass: "rp-layer-route-header-control",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.editRoute(s)
        }
      }
    }, [_c('span', {
      staticClass: "icon-cog"
    })])]), _vm._v(" "), (s.editing) ? _c('div', {
      staticClass: "clearfix rp-layer-route-settings"
    }, [_c('div', {
      staticClass: "pull-left"
    }, [_c('div', {
      staticClass: "btn-group btn-group-xs"
    }, [_c('button', {
      staticClass: "btn btn-default",
      class: {
        'btn-primary': s.mode == 'driving'
      },
      on: {
        "click": function($event) {
          _vm.setRouteMode(s, 'driving')
        }
      }
    }, [_c('span', {
      staticClass: "fa-icon icon-driving"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default",
      class: {
        'btn-primary': s.mode == 'transit'
      },
      on: {
        "click": function($event) {
          _vm.setRouteMode(s, 'transit')
        }
      }
    }, [_c('span', {
      staticClass: "fa-icon icon-transit"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default",
      class: {
        'btn-primary': s.mode == 'walking'
      },
      on: {
        "click": function($event) {
          _vm.setRouteMode(s, 'walking')
        }
      }
    }, [_c('span', {
      staticClass: "fa-icon icon-walking"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default",
      class: {
        'btn-primary': s.mode == 'bicycling'
      },
      on: {
        "click": function($event) {
          _vm.setRouteMode(s, 'bicycling')
        }
      }
    }, [_c('span', {
      staticClass: "fa-icon icon-bicycling"
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "pull-right rp-layer-route-checkboxes"
    }, [_c('div', {
      staticClass: "checkbox checkbox-inline"
    }, [_c('label', [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": s.notolls
      },
      on: {
        "change": function($event) {
          _vm.setRouteNoTolls(s, !s.notolls)
        }
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tNo Tolls\n\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
      staticClass: "checkbox checkbox-inline"
    }, [_c('label', [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": s.nohighways
      },
      on: {
        "change": function($event) {
          _vm.setRouteNoHighways(s, !s.nohighways)
        }
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tNo HW\n\t\t\t\t\t\t\t\t\t\t\t")])])])]) : _vm._e(), _vm._v(" "), (s.editing) ? _c('Draggable', {
      staticClass: "rp-layer-route-routes",
      attrs: {
        "options": {
          handle: '.rp-layer-route-draggable'
        },
        "value": s.waypoints
      },
      on: {
        "end": function($event) {
          _vm.moveWaypoint(s, $event)
        }
      }
    }, _vm._l((s.waypoints), function(w, i) {
      return _c('div', {
        staticClass: "input-group input-group-sm rp-layer-route-routes-item rp-layer-route-draggable"
      }, [_c('span', {
        staticClass: "input-group-addon"
      }, [_vm._v(_vm._s(i + 1))]), _vm._v(" "), _c('input', {
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "placeholder": "-- Empty destination --"
        },
        domProps: {
          "value": w
        },
        on: {
          "focus": function($event) {
            _vm.createWaypointAutocomplete(s, i, $event)
          },
          "blur": function($event) {
            _vm.destroyWaypointAutocomplete(s, i, $event)
          }
        }
      }), _vm._v(" "), (s.waypoints.length > 2) ? _c('a', {
        staticClass: "btn btn-default input-group-addon",
        on: {
          "click": function($event) {
            _vm.removeWaypoint(s, i)
          }
        }
      }, [_c('span', {
        staticClass: "icon icon-times"
      })]) : _vm._e()])
    })) : _c('div', {
      staticClass: "rp-layer-route-routes-view"
    }, [_vm._l((s.waypoints), function(w, i) {
      return _c('div', {
        staticClass: "rp-layer-routes-item"
      }, [_c('span', {
        staticClass: "badge"
      }, [_vm._v(_vm._s(i + 1))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(w))])])
    }), _vm._v(" "), _c('div', {
      staticClass: "rp-layer-route-routes-stat"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("distance")(s.distance)) + "\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("duration")(s.duration)) + "\n\t\t\t\t\t\t\t\t\t")])], 2), _vm._v(" "), (s.editing) ? _c('div', {
      staticClass: "clearfix"
    }, [_c('div', {
      staticClass: "pull-left"
    }, [_c('button', {
      staticClass: "btn btn-default btn-sm",
      on: {
        "click": function($event) {
          _vm.addWaypoint(s)
        }
      }
    }, [_c('span', {
      staticClass: "icon-plus"
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\tAdd waypoint\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
      staticClass: "pull-right"
    }, [(s.loading) ? _c('button', {
      staticClass: "btn btn-default btn-sm",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('span', {
      staticClass: "icon-loading icon-spin"
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\tLoading...\n\t\t\t\t\t\t\t\t\t\t")]) : _c('button', {
      staticClass: "btn btn-default btn-sm",
      on: {
        "click": function($event) {
          _vm.buildRoute(s)
        }
      }
    }, [_c('span', {
      staticClass: "icon-checkmark"
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\tApply\n\t\t\t\t\t\t\t\t\t\t")])])]) : _vm._e()], 1)] : _vm._e()]
  })], 2)], 1)]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6322a763"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/Layer.vue
// module id = 478
// module chunks = 0